/** Public export for the Pitch formation field. */
export { default } from "./WatchlistPitchFieldContainer";
